<template>
	<el-dialog :visible.sync="visible" title="规则设置" @close="reset">
		<div class="setting">
			<div class="tips mb-20 flex flex-align-center flex-just-between">
				<div class="flex flex-align-center ellipsis">
					<img src="@/assets/public/warning-org.png" alt="" />
					<p class="ml-6 ellipsis">
						若同个达人仅允许1个{{ drName }}跟进，则从线索认领就会校验关系的唯一性，达人带货订单均归属为{{ drName }}业绩(包括导入系统前所产生订单);
					</p>
				</div>
				<p class="details" @click="lookRule">查看详细规则 ></p>
			</div>
		</div>
		<div class="content">
			<p class="fz-14 yx-color-text-primary"> 是否允许多个{{ drName }}跟进同一个达人？ </p>
			<div class="mt-20 fz-14">
				<el-radio-group v-model="many_partner">
					<el-radio :disabled="task_status === 1" :label="0">不允许</el-radio>
					<el-radio :disabled="task_status === 1" :label="1">允许</el-radio>
				</el-radio-group>
			</div>
			<p class="mt-20 fz-14 yx-color-primary" v-if="task_status"> 部分数据正在订正中，暂时不支持修改规则，请耐心等待 </p>
			<div class="mt-16" v-if="!many_partner && !task_status && isShow">
				<p class="fz-13 mb-10">
					共计<span class="ml-6 mr-6 yx-color-primary">{{ total }}</span
					>个达人有多{{ drName }}跟进，重新确认达人与{{ drName }}1对1跟进关系后，其余{{ drName }}关于该达人的合作进度将由最终跟进{{ drName }}继承。
				</p>
				<el-table
					:data="tableData"
					border
					header-row-class-name="table-header-row"
					row-class-name="table-row"
					:cell-class-name="cellName"
					:span-method="arraySpanMethod"
					:header-cell-class-name="headerCellName"
				>
					<el-table-column label="达人信息">
						<template v-slot="{ row }">
							<div class="info flex flex-align-center">
								<div class="left">
									<yx-avatar :src="row.head"></yx-avatar>
								</div>
								<div class="right ml-10">
									<p class="yx-color-text-primary">{{ row.anchor_name }}</p>
									<div class="user-box flex flex-align-center">
										<platform-icon :platformId="row.platform_id"></platform-icon>
										<p class="yx-color-text-regular ml-6">
											<span>ID </span><span>{{ row.anchor_id }}</span>
										</p>
									</div>
									<p class="fz-13">粉丝数：{{ row.fans_num }}</p>
								</div>
							</div>
							<div class="error fz-12 mt-4" v-if="row.checked"> <i class="el-icon-warning mr-8"></i>请选择{{ drName }} </div>
						</template>
					</el-table-column>
					<el-table-column :label="drName">
						<template v-slot="{ row, $index }">
							<div
								:class="['partners', 'flex', !index ? 'top' : index + 1 === row.partners.length ? 'bottom' : 'middle']"
								v-for="(item, index) in row.partners"
								:key="index"
							>
								<p>{{ item.partner_role_name }}</p>
								<label class="el-radio label-radio">
									<input type="radio" value="checked" @change="radioFun(row.partners, index)" :name="row.anchor_id" v-model="item.checked" />
									<span class="el-radio__label">设为最终跟进人</span>
								</label>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200px"> </el-table-column>
					<template v-slot:empty v-if="true">
						<div class="empty mt-10 mb-20">
							<img src="@/assets/public/no-data-icon.png" alt="" />
							<p class="yx-color-text-secondary">暂无更正数据…</p>
						</div>
					</template>
				</el-table>
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="submit">确 认</el-button>
		</div>
		<el-dialog width="25%" :visible.sync="visibleRules" title="详细规则说明" :append-to-body="true">
			<div>
				<p>
					1、若同个达人仅允许1个{{ drName }}跟进，则从线索认领就会校验关系的唯一性，达人带货订单均归属为{{ drName }}业绩(包括导入系统前所产生订单);
				</p>
				<p class="mt-10">
					2、若多{{ drName }}允许跟进同1个达人，则根据专属商品链接所带参数来识别业绩归属，同时针对漏单(识别归属的订单)可手动补充{{ drName }}信息；
				</p>
				<p class="mt-10"> 3、{{ drName }}与达人跟进关系从多对1切换到1对1时，系统会将多人跟进的达人数据筛选出由您确定最终跟进的{{ drName }}； </p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="visibleRules = false">关 闭</el-button>
			</div>
		</el-dialog>
	</el-dialog>
</template>
<script>
import { getWaitFix, addFixTask, getPartnerAnchor } from '@/api/talentCRM';
import { drRoleType } from '@/utils/dataMap';
export default {
	data() {
		return {
			visible: false,
			visibleRules: false,
			many_partner: 1,
			followUp: false,
			tableData: [],
			wait_fix: '',
			task_status: '',
			total: '',
			isShow: false,
		};
	},
	computed: {
		drName() {
			return drRoleType.name;
		},
	},
	methods: {
		show(platformId) {
			this.getPartnerAnchor(platformId);
			this.visible = true;
		},
		async getPartnerAnchor(platform_id) {
			const { code, data } = await getPartnerAnchor({ platform_id });
			if (code === 0) {
				this.many_partner = data.many_partner;
				this.wait_fix = data.wait_fix;
				this.task_status = data.task_status;
				if (!this.task_status) {
					this.getWaitFixList(platform_id);
				}
			}
		},
		async getWaitFixList(platform_id) {
			const { code, data } = await getWaitFix({ platform_id });
			if (code === 0) {
				this.tableData = data;
				this.total = data.length;
				if (this.total) {
					this.isShow = true;
				}
			}
		},
		async submit() {
			if (this.task_status) {
				this.visible = false;
			} else {
				let bind_list = [];
				if (!this.many_partner) {
					let state_list = [];
					this.tableData.forEach((item, index) => {
						item.partners.forEach((it, ind) => {
							if (it.checked) {
								bind_list.push({ anchor_id: item.anchor_id, user_id: it.user_id });
							}
						});
						let isChecked = item.partners.some(ite => ite.checked);
						state_list.push(isChecked);
						if (isChecked) {
							this.$set(this.tableData[index], 'checked', false);
						} else {
							this.$set(this.tableData[index], 'checked', true);
						}
					});
					if (state_list.indexOf(false) !== -1) {
						return;
					}
				}
				const { code } = await addFixTask({ many_partner: this.many_partner, bind_list: bind_list });
				if (code === 0) {
					this.visible = false;
					this.$message.success('操作成功');
					this.$emit('getList');
				}
			}
		},
		radioFun(list, index) {
			list.forEach((item, ind) => {
				if (index !== ind) {
					delete item['checked'];
				}
			});
		},
		lookRule() {
			this.visibleRules = true;
		},
		arraySpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 1) {
				return [1, 2];
			}
		},
		cellName({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 1) {
				return 'special';
			}
		},
		headerCellName({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 1) {
				return 'header-special';
			}
		},
		reset() {
			this.many_partner = 1;
		},
	},
	components: {
		
	},
};
</script>
<style lang="less" scoped>
.tips {
	img {
		width: 16px;
		height: 16px;
	}
	background-color: #fef3e7;
	border: 1px solid #fba543;
	border-radius: 2px;
	padding: 11px 16px;
}
.ellipsis {
	flex: 1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.details {
	cursor: pointer;
	white-space: nowrap;
	color: #fba543;
}
.user-box {
	img {
		width: 16px;
		height: 16px;
	}
}
/deep/ .el-table__body-wrapper {
	max-height: 300px;
	overflow-y: auto;
}
.empty {
	img {
		width: 160px;
		height: 160px;
	}
}
.partners {
	display: flex;
	justify-content: space-between;
	p {
		margin-left: 16px;
	}
}
.top {
	padding-bottom: 16px;
}
.middle {
	border-top: 1px solid #eeeeee;
	padding: 16px 0px;
}
.bottom {
	border-top: 1px solid #eeeeee;
	padding-top: 16px;
}
.label-radio {
	margin-right: 60px;
	display: flex;
	align-items: center;
}
.error {
	position: absolute;
	top: 10px;
	right: 10px;
	color: @color-danger;
	text-align: center;
}
/deep/ .special .cell {
	padding: 0px 0px !important;
}
/deep/ .header-special {
	border-right: 1px solid transparent !important;
}
</style>
